import { Result } from '@/generic/functional';

const LOWER_VALUE = 0;
const HIGHER_VALUE = 100;

const isOutOfRange = (number: number) => number < LOWER_VALUE || number > HIGHER_VALUE;

export class Progress {
  readonly #value: number;

  private constructor(value: number) {
    this.#value = value;
  }

  static start(): Progress {
    return new Progress(LOWER_VALUE);
  }

  static of(number: number): Result<Error, Progress> {
    if (isOutOfRange(number)) {
      return Result.error(new Error(`Progress: ${number} is not between 0 and 100.`));
    }
    return Result.success(new Progress(number));
  }

  get value(): number {
    return this.#value;
  }

  get readable(): string {
    return `${this.#value}%`;
  }
}
